import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-arrow--up",
  "use": "icon-arrow--up-usage",
  "viewBox": "0 0 14 9",
  "content": "<symbol fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 14 9\" id=\"icon-arrow--up\"><path d=\"M1 8l6-6 6 6\" stroke=\"currentColor\" stroke-width=\"1.5\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol